<template>
  <button type="button" class="button" :class="buttonClassName" @click="onClick" :disabled="isButtonDisabled">
    <slot name="pre-icon"></slot>
    <slot name="text"></slot>
    <slot name="post-icon"></slot>
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    className: {
      type: String,
      default: '',
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    buttonClassName() {
      let classNameTemporary = ''

      switch (this.variant) {
        case 'primary':
          classNameTemporary = 'is-primary';
          break;

        case 'primary-outlined':
          classNameTemporary = 'is-primary-outlined';
          break;

        case 'secondary':
          classNameTemporary = 'is-secondary';
          break;

        case 'secondary-outlined':
          classNameTemporary = 'is-secondary-outlined';
          break;

        case 'default':
          classNameTemporary = 'default';
          break;

        case 'default-outlined':
          classNameTemporary = 'default-outlined';
          break;

        case 'danger':
          classNameTemporary = 'is-danger'
          break;

        case 'danger-outlined':
          classNameTemporary = 'danger-outlined'
          break;

        case 'darkblue-outlined':
          classNameTemporary = 'darkblue-outlined'
          break;

        case 'text':
          classNameTemporary = 'is-text'
          break;
      
        default:
          classNameTemporary = '';
          break;
      }

      classNameTemporary = `${classNameTemporary} ${this.className}`
    
      return this.isLoading ? `is-loading ${classNameTemporary}` : classNameTemporary
    },

    isButtonDisabled() {
      return this.isLoading ? true : this.disabled      
    }
  },
}
</script>

<style scoped>
.button {
  padding: 12px 24px;
  border-radius: 8px;
}
</style>
